// Generated by ReScript, PLEASE EDIT WITH CARE


import * as Sentry from '@sentry/react';
;

var init = (function (init_options) {
      if (Sentry.getClient()) return;

      const ignoreErrors = [
        /Cannot read property 'getReadModeExtract' of undefined/i,
        /Cannot read property 'getReadModeRender' of undefined/i,
        /Cannot read property 'getReadModeConfig' of undefined/i,
        /ibFindAllVideos is not defined/i
      ];

        Sentry.init({
        dsn: init_options.dsn,
        environment: init_options.env,
        tracesSampleRate: 0.1,
        release: "fe-website-platform",
        replaysSessionSampleRate: 0.01,
        replaysOnErrorSampleRate: 0.01,
        ignoreErrors,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
          }),
        ],
        })
      });

export {
  init ,
}
/*  Not a pure module */
